import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Mirrors document-chatbot/src/components/markdown.tsx styling (plain CSS classes).
 */
export function DeviceChatMarkdown({ content }) {
  return (
    <div className="dcu-md-root">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}

function Pre(props) {
  return <pre className="dcu-md-pre" {...props} />;
}

function Code({ className, children, ...props }) {
  const isBlock = /language-/.test(className || '');
  if (isBlock) {
    return (
      <code className={`${className || ''} dcu-md-code-block`} {...props}>
        {children}
      </code>
    );
  }
  return (
    <code className="dcu-md-code-inline" {...props}>
      {children}
    </code>
  );
}

const components = {
  pre: Pre,
  h1: ({ children, ...rest }) => (
    <h1 className="dcu-md-h1" {...rest}>
      {children}
    </h1>
  ),
  h2: ({ children, ...rest }) => (
    <h2 className="dcu-md-h2" {...rest}>
      {children}
    </h2>
  ),
  h3: ({ children, ...rest }) => (
    <h3 className="dcu-md-h3" {...rest}>
      {children}
    </h3>
  ),
  h4: ({ children, ...rest }) => (
    <h4 className="dcu-md-h4" {...rest}>
      {children}
    </h4>
  ),
  p: (props) => <p className="dcu-md-p" {...props} />,
  ul: (props) => <ul className="dcu-md-ul" {...props} />,
  ol: (props) => <ol className="dcu-md-ol" {...props} />,
  li: (props) => <li className="dcu-md-li" {...props} />,
  code: Code,
  a: ({ children, ...rest }) => (
    <a
      className="dcu-md-a"
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {children}
    </a>
  ),
  blockquote: (props) => <blockquote className="dcu-md-bq" {...props} />,
  table: (props) => (
    <div className="dcu-md-table-wrap">
      <table className="dcu-md-table" {...props} />
    </div>
  ),
  th: (props) => <th className="dcu-md-th" {...props} />,
  td: (props) => <td className="dcu-md-td" {...props} />,
  hr: () => <hr className="dcu-md-hr" />,
  strong: (props) => <strong className="dcu-md-strong" {...props} />,
  em: (props) => <em className="dcu-md-em" {...props} />,
};
